import type { ApiRequestBody, ApiResponseBody, ApiSearchQuery } from '@/lib/api/api-type-helper';
export type GetPlaceSocialInsurancesParams = ApiSearchQuery<'/v2/social-insurance-places', 'get'>;
export type OrderBy = Exclude<GetPlaceSocialInsurancesParams['orderBy'], undefined>;
export const ORDER_BY = {
  socialInsuranceName: 'name',
  createdAt: 'createdAt'
} satisfies Record<string, OrderBy>;
export type GetPlaceSocialInsurancesRes = ApiResponseBody<'/v2/social-insurance-places', 'get'>;
export type GetAvailablePlacesParams = ApiSearchQuery<'/v2/social-insurance-places/available-places', 'get'>;
export type RegisterPlaceSocialInsuranceParams = ApiRequestBody<'/v2/social-insurance-places/register', 'post'>;
export type RegisterPlaceSocialInsuranceRes = ApiResponseBody<'/v2/social-insurance-places/register', 'post'>;